import { VehicleTransportService } from 'src/app/vehicle-transport/vehicle-transport.service';
import { GlobalService } from 'src/app/global.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from 'src/app/http.service';
import { GlobalValidationService } from 'src/app/global-validation.service';

@Component({
  selector: 'app-vehicle-transport-register',
  templateUrl: './vehicle-transport-register.component.html',
  styleUrls: ['./vehicle-transport-register.component.scss']
})
export class VehicleTransportRegisterComponent {

  vehicle_transport_register_from: FormGroup;
  action: 'register' | 'update' = null;
  vehicle_transports = [];

  constructor(private formBuilder: FormBuilder, private http: HttpService, private global: GlobalService, public service: VehicleTransportService) {
    this.vehicle_transport_register_from = this.formBuilder.group({
      id: [null, Validators.compose([])],
      name: [null, Validators.compose([Validators.required])],
      contact_person: [null, Validators.compose([Validators.required])],
      mobile: [null, Validators.compose([GlobalValidationService.checkMobileNumber])],
      alternate_mobile: [null],
      address: [null, Validators.compose([Validators.required])],
      latitude: [null, Validators.compose([])],
      longitude: [null, Validators.compose([])],
    });

    if (this.service.get_vehicle_transport_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.service.get_vehicle_transport_data);
    }
    this.service.vehicleTransportUpdate.subscribe((vehicle_transport) => {
      this.setupUpdateForm(vehicle_transport);
    });
  }

  registerVehicleTransport() {
    this.http.registerVehicleTransport(this.vehicle_transport_register_from.value).subscribe((data) => {
      console.log(data);
      this.global.showSnakeBar(data['message']);
      this.service.downloadVehicleTransport.emit(true);
      this.service.is_display_vehile_transport_register_component = false
      this.vehicle_transport_register_from.reset();
    }, (error) => {
      console.log(error);
    });
  }


  setupUpdateForm(vehicle_transport) {
    console.log(vehicle_transport);
    this.vehicle_transport_register_from.controls['id'].setValue(vehicle_transport['id']);
    this.vehicle_transport_register_from.controls['name'].setValue(vehicle_transport['name']);
    this.vehicle_transport_register_from.controls['contact_person'].setValue(vehicle_transport['contact_person']);
    this.vehicle_transport_register_from.controls['mobile'].setValue(vehicle_transport['mobile']);
    this.vehicle_transport_register_from.controls['alternate_mobile'].setValue(vehicle_transport['alternate_mobile']);
    this.vehicle_transport_register_from.controls['address'].setValue(vehicle_transport['address']);
    this.vehicle_transport_register_from.controls['latitude'].setValue(vehicle_transport['latitude']);
    this.vehicle_transport_register_from.controls['longitude'].setValue(vehicle_transport['longitude']);
  }
}
